import { Component, OnInit, ViewChild } from '@angular/core';
import { CodeCommitService } from 'src/services/codecommit.service';
import { AppService } from 'src/app/app.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-new-logs',
  templateUrl: './new-logs.component.html',
  styleUrls: ['./new-logs.component.css']
})
export class NewLogsComponent implements OnInit {

  public isSelected: boolean = false;
  public loginUser: any = '';
  public usersLastList = [];
  public year: any = moment().format('YYYY');
  public repositoriesDetail: any = [];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  constructor(
    private appService: AppService,
    private codeCommitService: CodeCommitService
  ) { }
  ngOnInit() {
    this.appService.headerTitle.emit({
      data: "CodeCommit"
    });

    this.loginUser = JSON.parse(localStorage.getItem('user'));
    this.getRepositoriesDetails();
    this.getUsersLastModified();
    
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  getRepositoriesDetails() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 25,
      dom: 'frtlip',
      ordering: false,
      // order: [[2, 'desc']],
     // processing: true,
      "destroy": true,     "columnDefs": [
        { "width": "12%", "orderable": false, "targets": 0 },
        { "width": "15%","orderable": false, "targets": 1 },
        { "width": "15%","orderable": false, "targets": 2 },
        { "width": "30%", "orderable": false, "targets": 3 },
        { "width": "12%", "orderable": false, "targets": 4 }
        

      ]
    };
    this.codeCommitService.getRepositoriesnewLog().subscribe(response => {
      if (response.status == "ok") {
        $(".custom-loader-aws").css("display", "none");
        $(".loader-response-aws").css("display", "block");
        this.repositoriesDetail = response.data.value;
        //console.log(this.repositoriesDetail);
        this.rerender();
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  getUsersLastModified() {
    this.codeCommitService.getLastModified().subscribe((response) => {
      if (response.status == "ok") {
        this.usersLastList = response.data;
        console.log(this.usersLastList);
        // for (var i = 0; i < this.usersLastList.length; i++) {
        //   this.usersLastList[i].userName = this.usersLastList[i].userName.split(" ")[0];
        // }
      }
    }, error => {
      if (error.status == 401) { }
    });
  }
  getDateColorClass(lastModified: Date): string {
  const currentDate = new Date();
  const lastModifiedDate = new Date(lastModified);
  const diffTime = Math.abs(currentDate.getTime() - lastModifiedDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 3) {
    return 'border-green';
  } else if (diffDays <= 6) {
    return 'border-orange';
  } else {
    return 'border-red';
  }
}
getUserDisplayName(userName: string): string {
  if (!userName) return '';
  
  const nameParts = userName.trim().split(' ');
  
  // Agar first name sirf 'M' hai, toh second name return karo
  if (nameParts[0] === 'M' && nameParts.length > 1) {
    return nameParts[1];
  }
  
  // Agar first name 'Muhammad' hai, toh second name return karo
  if (nameParts[0].toLowerCase() === 'muhammad' && nameParts.length > 1) {
    return nameParts[1];
  }
  
  // Otherwise first name return karo
  return nameParts[0];
}
  toggleCollapse() {
    if (this.isSelected) {
      this.isSelected = false;
    } else {
      this.isSelected = true;
    }
  }
}
